module.exports = __webpack_public_path__ + "img/product1-2.ce2f5837.jpg";